import React, { useState, useEffect, useRef } from 'react';
import { RadioSelector, Button, ErrorMsg } from "@onegovbugs/onegov-react-components";
import styles from "../common/prerequisites/prerequisites.module.scss";
import { storeDisclosures, saveApplication } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from 'react-router-dom';
import { isSelected, validate, scrollToError } from "../../utils/Validation";
import { RedirectIfCaptchaNotSelected, RedirectIfPrerequisitesNotSelected } from '../../utils/redirect';
import ScrollToTop from '../../utils/scrollToTop';
import { TATTOO_OPERATOR_FORM } from "../../constants";

const Disclosures = props => {
  RedirectIfCaptchaNotSelected(props);
  RedirectIfPrerequisitesNotSelected(props);
  ScrollToTop();

  const dispatch = useDispatch();
  const form = useSelector(state => state.form);
  const disclosures = useSelector(state => state.disclosures);

  const [applicationEverRefused, setApplicationEverRefused] = useState(disclosures ? disclosures.applicationEverRefused : null);
  const [applicationEverRefusedComment, setApplicationEverRefusedComment] = useState(disclosures ? disclosures.applicationEverRefusedComment : null);
  const [heldSuspendedDocument, setHeldSuspendedDocument] = useState(disclosures ? disclosures.heldSuspendedDocument : null);
  const [heldSuspendedDocumentComment, setHeldSuspendedDocumentComment] = useState(disclosures ? disclosures.heldSuspendedDocumentComment : null);
  const [disciplinaryAgainstYou, setDisciplinaryAgainstYou] = useState(disclosures ? disclosures.disciplinaryAgainstYou : null);
  const [disciplinaryAgainstYouComment, setDisciplinaryAgainstYouComment] = useState(disclosures ? disclosures.disciplinaryAgainstYouComment : null);
  const [disqualifiedToHoldLicence, setdisqualifiedToHoldLicence] = useState(disclosures ? disclosures.disqualifiedToHoldLicence : null);
  const [disqualifiedToHoldLicenceComment, setdisqualifiedToHoldLicenceComment] = useState(disclosures ? disclosures.disqualifiedToHoldLicenceComment : '');

  const radioOptionsYesNo = [
    {
      value: 'yes',
      label: 'Yes'
    },
    {
      value: 'no',
      label: 'No'
    }
  ];

  const [showErrors, setShowErrors] = useState(false);

  useEffect(() => {
    validate(validators, setErrors)
  }, [applicationEverRefused, heldSuspendedDocument, disciplinaryAgainstYou, applicationEverRefusedComment, heldSuspendedDocumentComment, disciplinaryAgainstYouComment, disqualifiedToHoldLicenceComment]);

  const storeData = () => {
    dispatch(storeDisclosures({
      applicationEverRefused, heldSuspendedDocument, disciplinaryAgainstYou,disqualifiedToHoldLicence, applicationEverRefusedComment, heldSuspendedDocumentComment, disciplinaryAgainstYouComment, disqualifiedToHoldLicenceComment
    }));
  };


  const validators = [
    {
      fieldName: "applicationEverRefused",
      fieldValue: applicationEverRefused,
      isValid: (v) => (isSelected(v)),
    },
    {
      fieldName: "heldSuspendedDocument",
      fieldValue: heldSuspendedDocument,
      isValid: (v) => (isSelected(v)),
    },
    {
      fieldName: "disciplinaryAgainstYou",
      fieldValue: disciplinaryAgainstYou,
      isValid: (v) => (isSelected(v)),
    },
    {
        fieldName: "disqualifiedToHoldLicence",
        fieldValue: disqualifiedToHoldLicence,
        isValid: (v) => (isSelected(v)),
    },
    {
      fieldName: "applicationEverRefusedComment",
      fieldValue: applicationEverRefusedComment,
      isValid: (v) => applicationEverRefused === 'no' || (applicationEverRefused === 'yes' && (isSelected(v))),
    },
    {
      fieldName: "heldSuspendedDocumentComment",
      fieldValue: heldSuspendedDocumentComment,
      isValid: (v) => heldSuspendedDocument === 'no' || (heldSuspendedDocument === 'yes' && (isSelected(v))),
    },
    {
      fieldName: "disciplinaryAgainstYouComment",
      fieldValue: disciplinaryAgainstYouComment,
      isValid: (v) => disciplinaryAgainstYou == 'no' || (disciplinaryAgainstYou === 'yes' && (isSelected(v))),
    },
    {
      fieldName: "disqualifiedToHoldLicenceComment",
      fieldValue: disqualifiedToHoldLicenceComment,
      isValid: (v) => disqualifiedToHoldLicence === 'no' || (disqualifiedToHoldLicence === 'yes' && (isSelected(v))),
  }
  ];

  const [errors, setErrors] = useState({
    applicationEverRefused: false,
    heldSuspendedDocument: false,
    disciplinaryAgainstYou: false,
    disqualifiedToHoldLicence: false,
    applicationEverRefusedComment: false,
    heldSuspendedDocumentComment: false,
    disciplinaryAgainstYouComment: false,
    disqualifiedToHoldLicenceComment: false
  });

  return <div className={styles.mainCont}>

    <div className={'row'}>
      <div className={'col-12'}>
        <p className={styles.radioOptionsHeading}>Have you ever had an application for a tattoo industry licence/permit refused?</p>
        <RadioSelector
          options={radioOptionsYesNo}
          onSelectionChange={(selectedValue) => {
            setApplicationEverRefused(selectedValue);

          }}
          initialValue={applicationEverRefused}
        />
        {applicationEverRefused && applicationEverRefused === 'yes' ?
          <>
            <label htmlFor={"applicationEverRefusedComment"}>If your answer is Yes, provide full details below. </label>
            <textarea
              value={applicationEverRefusedComment}
              onChange={obj => {
                setApplicationEverRefusedComment(obj.target.value);
              }}
              rows={5}
              cols={5}
            />
          </> : null}
      </div>
      {applicationEverRefused == null && errors.applicationEverRefused && showErrors ? (
        <div className={`col-12 ${styles.errorContainer}`}>
          <ErrorMsg className={"ErrorMsg_error"}
            type={"error"}
            description={"Please make a selection."}
          />
        </div>
      ) : null}
      {applicationEverRefused && errors.applicationEverRefusedComment && showErrors ? (
        <div className={`col-12 ${styles.errorContainer}`}>
          <ErrorMsg className={"ErrorMsg_error"}
            type={"error"}
            description={"Further details is required."}
          />
        </div>
      ) : null}
    </div>
    <div className={'row'}>
      <div className={'col-12'}>
        <p className={styles.radioOptionsHeading}>Have you ever had a tattoo industry licence/permit suspended, cancelled or revoked in New South Wales or elsewhere?</p>
        <RadioSelector
          options={radioOptionsYesNo}
          onSelectionChange={(selectedValue) => {
            setHeldSuspendedDocument(selectedValue);
          }}
          initialValue={heldSuspendedDocument}
        />
        {heldSuspendedDocument && heldSuspendedDocument === 'yes' ?
          <>
            <label htmlFor={"heldSuspendedDocumentComment"}>If your answer is Yes, provide full details below. </label>
            <textarea
              value={heldSuspendedDocumentComment}
              onChange={obj => {
                setHeldSuspendedDocumentComment(obj.target.value);
              }}
              rows={5}
              cols={5}
            />
          </> : null}
      </div>
      {heldSuspendedDocument == null && errors.heldSuspendedDocument && showErrors ? (
        <div className={`col-12 ${styles.errorContainer}`}>
          <ErrorMsg className={"ErrorMsg_error"}
            type={"error"}
            description={"Please make a selection."}
          />
        </div>
      ) : null}
      {heldSuspendedDocument && errors.heldSuspendedDocumentComment && showErrors ? (
        <div className={`col-12 ${styles.errorContainer}`}>
          <ErrorMsg className={"ErrorMsg_error"}
            type={"error"}
            description={"Further details is required."}
          />
        </div>
      ) : null}
    </div>
    <div className={'row'}>
      <div className={'col-12'}>
          <p className={styles.radioOptionsHeading}>Are you disqualified from holding a tattoo industry licence/permit in New South Wales or elsewhere?</p>
          <RadioSelector
              options={radioOptionsYesNo}
              onSelectionChange={(selectedValue) => {
                  setdisqualifiedToHoldLicence(selectedValue);
              }}
              initialValue={disqualifiedToHoldLicence}
          />
          {disqualifiedToHoldLicence && disqualifiedToHoldLicence === 'yes' ?
              <>
                  <label htmlFor={"disqualifiedToHoldLicenceComment"}>If your answer is Yes, provide full details below. </label>
                  <textarea
                      value={disqualifiedToHoldLicenceComment}
                      onChange={obj => {
                          setdisqualifiedToHoldLicenceComment(obj.target.value);
                      }}
                      rows={5}
                      cols={5}
                  />
              </> : null}
      </div>
      {disqualifiedToHoldLicence == null && errors.disqualifiedToHoldLicence && showErrors ? (
          <div className={`col-12 ${styles.errorContainer}`}>
              <ErrorMsg className={"ErrorMsg_error"}
                  type={"error"}
                  description={"Please make a selection."}
              />
          </div>
      ) : null}
      {disqualifiedToHoldLicence && errors.disqualifiedToHoldLicenceComment && showErrors ? (
          <div className={`col-12 ${styles.errorContainer}`}>
              <ErrorMsg className={"ErrorMsg_error"}
                  type={"error"}
                  description={"Further details is required."}
              />
          </div>
      ) : null}

    </div>
    <div className={'row'}>
      <div className={'col-12'}>
        <p className={styles.radioOptionsHeading}>Within the last 10 years, have you been to court in New South Wales or elsewhere and been convicted of an offence?</p>
        <RadioSelector
          options={radioOptionsYesNo}
          onSelectionChange={(selectedValue) => {
            setDisciplinaryAgainstYou(selectedValue);
          }}
          initialValue={disciplinaryAgainstYou}
        />
        {disciplinaryAgainstYou && disciplinaryAgainstYou === 'yes' ?
          <>
            <label htmlFor={"disciplinaryAgainstYouComment"}>If your answer is Yes, provide full details below. </label>
            <textarea
              value={disciplinaryAgainstYouComment}
              onChange={obj => {
                setDisciplinaryAgainstYouComment(obj.target.value);
              }}
              rows={5}
              cols={5}
            />
          </> : null}
      </div>
      {disciplinaryAgainstYou == null && errors.disciplinaryAgainstYou && showErrors ? (
        <div className={`col-12 ${styles.errorContainer}`}>
          <ErrorMsg className={"ErrorMsg_error"}
            type={"error"}
            description={"Please make a selection."}
          />
        </div>
      ) : null}
      {disciplinaryAgainstYou && errors.disciplinaryAgainstYouComment && showErrors ? (
        <div className={`col-12 ${styles.errorContainer}`}>
          <ErrorMsg className={"ErrorMsg_error"}
            type={"error"}
            description={"Further details is required."}
          />
        </div>
      ) : null}
    </div>



    <div className={`row ${styles.buttonCont}`}>
      <div className={`col-12`}>
        <Button
          onClick={() => {
            if (validate(validators, setErrors)) {
              setShowErrors(false);
              storeData();
              props.history.push(`./proof-of-residency`);
            } else {
              setShowErrors(true);
              scrollToError();
            }
          }}>Continue</Button>
        <Button
          secondary
          onClick={() => {
            storeData();
            dispatch(
              saveApplication("step3", () => {
                {
                  form.form === TATTOO_OPERATOR_FORM ?
                    props.history.push(`./dashboard`) :
                    window.location.href = `${process.env.REACT_APP_BAU_URL}`
                }
              })
            );
          }}
        >
          Save & exit section
          </Button>
      </div>
    </div>
  </div>
};

export default withRouter(props => <Disclosures {...props} />);
